export default __webpack_public_path__ + "static/media/park_pinpoint.1c2aba91.svg";